import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AddConnectionComponent } from '../../add-connection-component/add-connection.component';
import { MatDialog } from '@angular/material/dialog';
import { ConnectionsSearchComponent } from '../../connections-search-component/connections-search.component';
import { ManageExitingUserListType, ManageUserListType } from './manage-users.interface';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageUsersComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('inputField', { read: ElementRef }) inputField: ElementRef<HTMLInputElement>;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  @Input() userType;
  @Input() data: ManageUserListType[] = [];
  @Input() placeHolder = 'Search Connections';
  @Input() selectedUsers: ManageExitingUserListType[] = [];
  @Input() isComboInput = false;
  @Input() isInputFullWidth = false;
  @Input() isAccessManager = false;
  @Input() isbalanceSheetOwner = false;
  @Input() isBalanceSheetMember = false;
  @Input() isShowFooter = true;
  @Input() isWhiteBackgroundInput = false;
  @Input() isShowGlobalSearch = true;
  @Input() isShowCreateNewUser = true;
  @Input() disableSearch: boolean = false;
  @Output() openInviteDialog: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectConnectedUser: EventEmitter<any> = new EventEmitter<any>();
  @Output() onComboInputBlur: EventEmitter<any> = new EventEmitter<any>();

  connectionUserFormControl = new UntypedFormControl();
  isInputFocused: boolean = false;
  loader: boolean = false;
  ignoreProfessional: boolean = false;
  searchText = '';
  subscription = new Subscription();
  @Input() isManageGuardian = false;
  @Input() isFromManageVault = false;
  constructor(private store: Store, private cd: ChangeDetectorRef, private dialog: MatDialog) {}

  ngOnInit(): void {
    if (this.isManageGuardian) {
      this.isShowFooter = false;
    }
    if (this.userType === 'Professional') {
      this.ignoreProfessional = true;
    }

    if (this.disableSearch) {
      this.connectionUserFormControl.disable();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedUsers']) {
    }
  }
  onFocusFromParent() {
    setTimeout(() => {
      this.inputField.nativeElement.focus();
      this.isInputFocused = true;
    });
  }

  onMemberSearch(value) {
    this.connectionUserFormControl.setValue(value);
    this.cd.detectChanges();
  }

  onInputFocus() {
    this.isInputFocused = true;
  }

  onInputBlur() {
    this.isInputFocused = false;
    if (this.onComboInputBlur) {
      this.inputField.nativeElement.blur();
      this.onComboInputBlur.emit();
    }
  }

  onClearInput() {
    this.autocomplete.closePanel();
    this.connectionUserFormControl.setValue('');
    this.cd.detectChanges();
  }

  selectUser(user: any) {
    this.connectionUserFormControl.disable();
    this.selectConnectedUser.emit(user);
    setTimeout(() => {
      this.connectionUserFormControl.enable();
    }, 500);
  }

  setSelectedUsers() {
    this.cd.detectChanges();
    this.cd.markForCheck();
  }

  openInvite1() {
    this.connectionUserFormControl.disable();
    this.openInviteDialog.emit();
    setTimeout(() => {
      this.connectionUserFormControl.enable();
    }, 500);
  }

  openInvite() {
    const modalRef3 = this.dialog.open(AddConnectionComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      data: {
        fromAddVault: true,
        fromSharing: true,
        custom_user_type: this.userType && this.userType === 'professional' ? UserTypeEnum.Professional : '',
      },
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe((res) => {
        this.inputField.nativeElement.blur();
        this.isInputFocused = false;
        this.autocomplete.closePanel();
        this.cd.detectChanges();
        if (res) {
          const itemData = {
            ...res,
            ...(!res.user_id && { user_id: res.id }),
            ...(!res?.connection_status && { connection_status: 'invited' }),
          };
          this.selectConnectedUser.emit(itemData);
          this.autocomplete.closePanel();
          this.isInputFocused = false;
          this.inputField.nativeElement.blur();
          this.cd.detectChanges();
        }
      })
    );
  }

  addExistingUsers() {
    this.isInputFocused = false;
    const addedUser = this.selectedUsers.map(({ user_id }) => ({ user_id }));
    const dialogRef = this.dialog.open(ConnectionsSearchComponent, {
      panelClass: 'full-window-dialog-2',
      data: {
        title: 'Global User Search',
        placeholderText: 'Search Other Users',
        fromLinkedTemplate: true,
        user_type: this.userType ? (this.userType === 'professional' ? UserTypeEnum.Professional : UserTypeEnum.Standard) : '',
        existingUsers: addedUser,
        requestForAddedUserData: true,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        this.inputField.nativeElement.blur();
        this.isInputFocused = false;
        this.autocomplete.closePanel();
        this.cd.detectChanges();
        if (res) {
          this.selectConnectedUser.emit(res);
          this.autocomplete.closePanel();
          this.isInputFocused = false;
          this.cd.detectChanges();
        }
      })
    );
  }

  openGlobalSearch() {
    this.connectionUserFormControl.disable();
    setTimeout(() => {
      this.connectionUserFormControl.enable();
    }, 500);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  handleReturnSliceListCount() {
    return this.isFromManageVault ? this.data?.length ?? 5 : 5;
  }
}
